import React from "react";
import { useDispatch, useSelector } from "src/store";
import { HoverRow } from "src/ui/shared/table/HoverRow";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";

import { selectGroupDetails, showDetails } from "@dashboard/devices/store";
import ElasticService from "@services/elasticService";
import { Cell, flexRender, Row } from "@tanstack/react-table";

import { GroupOverviewData } from "../GroupPage.utils";

const ignoredColumns = ["name", "action", "numberOfDevices"];

export const GroupTableRow = (props: Row<GroupOverviewData>) => {
    const dispatch = useDispatch();
    const details = useSelector(selectGroupDetails);

    const onClick = (cell: Cell<GroupOverviewData, unknown>) => {
        ElasticService.createTransaction("tableElementClick", {
            table: "groups",
            click_element: cell.column.id === "description" ? "link" : "text",
        });

        if (cell.row.original.id && !ignoredColumns.includes(cell.column.id)) {
            dispatch(
                showDetails({
                    type: "group",
                    selectedId: cell.row.original.id,
                }),
            );
        }
    };

    return (
        <HoverRow<GroupOverviewData> {...props} selected={details?.selectedId === props.original.id}>
            {props.getVisibleCells().map((cell) => {
                const cellContent = flexRender(cell.column.columnDef.cell, cell.getContext());
                return (
                    <MinimalTableCell key={cell.id} onClick={() => onClick(cell)}>
                        {cellContent}
                    </MinimalTableCell>
                );
            })}
        </HoverRow>
    );
};
